export default __webpack_public_path__ + "static/media/yabe_image2.eba2cad7.png";